import { useMediaQuery } from "@mui/material";
import { useDispatch } from "react-redux";

import useI18N from "../hooks/useI18N";
import { setNetworkIssue } from "../redux/slices/app.slices";
import { MUIStyled } from "../shared/MUIStyled";
import SABox from "../shared/SABox";
import SAButton from "../shared/SAButton";
import SATypography from "../shared/SATypography";
import theme from "../themes/theme";

const StyledBox = MUIStyled(SABox)(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: 9999,
  backgroundColor: "#fff",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(3),
}));

const NetworkIssue = () => {
  const { t } = useI18N();
  const dispatch = useDispatch();
  const screenMd = useMediaQuery(theme.breakpoints.down("md"));

  const handleRetry = () => {
    dispatch(setNetworkIssue(false));
    window.location.reload();
  };

  return (
    <StyledBox>
      <img
        src="/icons/network-issue-image.png"
        alt="no-internet"
        style={{
          width: screenMd ? "180px" : "280px",
          maxWidth: "100%",
          marginBottom: "32px",
        }}
      />
      <SATypography
        variant={screenMd ? "h5" : "h4"}
        component="h1"
        sx={{
          color: "#CCB16A",
          fontWeight: 700,
          mb: 2,
          textAlign: "center",
        }}
      >
        {t("network-issue-title")}
      </SATypography>
      <SATypography
        variant={screenMd ? "body2" : "body1"}
        sx={{
          color: theme.palette.text.secondary,
          mb: 4,
          textAlign: "center",
          maxWidth: "500px",
        }}
      >
        {t("network-issue-desc")}
      </SATypography>
      <SAButton variant="contained" onClick={handleRetry}>
        {t("try-again")}
      </SAButton>
    </StyledBox>
  );
};

export default NetworkIssue;
